module.exports = __webpack_public_path__ + "img/sld_star_delta_transformer_aux.ffc73118.svg";